<script>
    import messages from "/core/stores/alertsStore.js";

    import SuccessAlert from "./SuccessAlert.svelte";
    import InfoAlert from "./InfoAlert.svelte";
    import WarningAlert from "./WarningAlert.svelte";
    import DangerAlert from "./DangerAlert.svelte";

    import { fly,fade } from 'svelte/transition';

    function handleCancelAlert(event) {
        messages.deleteByHash(event.detail.hash);
    }

</script>

<div class='row'>
    <div class='col-sm-12 col-md-6 offset-md-6'>
        <section class="alerts-container-box position-fixed top-0 end-0 mt-1 me-1 ms-1">
            {#each $messages as m}
                {#if m.type == 'success'}
                    <div in:fade|global out:fly|global>
                        <SuccessAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
                {#if m.type == 'info'}
                    <div in:fade|global out:fly|global>
                        <InfoAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
                {#if m.type == 'warning'}
                    <div in:fade|global out:fly|global>
                        <WarningAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
                {#if m.type == 'danger'}
                    <div in:fade|global out:fly|global>
                        <DangerAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
            {/each}
        </section>
    </div>
</div>

<style>
    .alerts-container-box {
        z-index: 100;
    }
</style>